import { Util } from "./util";
import { DomHelper } from "./domHelper";
import { sendBackendData } from "./xhrbackend";
import { DEBUG } from "./config";
import { logEvents, sessionid } from "./desk";
function handleHelpClick(event, href) {
    const clickedNode = event.target;
    if (clickedNode && (clickedNode.tagName.toUpperCase() === "SUMMARY" || clickedNode.classList.contains('rudi-app-desc'))) {
        console.log("Doing nothing");
    }
    else if (clickedNode && clickedNode.classList.contains('rudi-app-help')) {
        event.stopPropagation();
        const url = clickedNode.getAttribute('targeturl');
        if (url)
            window.open(url, '_blank');
    }
    else if (clickedNode && clickedNode.classList.contains('fa-star')) {
        event.stopPropagation();
    }
    else {
        window.open(href, '_blank');
    }
}
function handleDefaultClick(event, href) {
    if (href)
        window.open(href, '_blank');
    return false;
}
function getColorSettings(userPreferences, app) {
    if (userPreferences.settings) {
        let appSetting = userPreferences.settings.find(element => element.cn == app.cn);
        if (appSetting && appSetting.color)
            return appSetting.color;
    }
    if (app.odAppConfig) {
        let appConfig = JSON.parse(app.odAppConfig);
        if (appConfig.defaultColor)
            return appConfig.defaultColor;
    }
    throw "No color Setting found";
}
export function getAppCardNode(parentNode, app, username, userPreferences, bearerToken, networkRestricted = false, additionalClassList, myJSON, clickHandler) {
    let href = "";
    let appConfig = {};
    if (app.odAppConfig)
        appConfig = JSON.parse(app.odAppConfig);
    if (!additionalClassList) {
        additionalClassList = additionalClassList || [];
    }
    additionalClassList.push('rudi-app');
    additionalClassList.push('rudi-max-height');
    try {
        additionalClassList.push(getColorSettings(userPreferences, app));
    }
    catch (e) {
    }
    let appNode = DomHelper.appendNode(parentNode, 'article', additionalClassList, [
        { attr: 'ldap-dn', value: app.dn },
        { attr: 'id', value: app.cn },
        { attr: 'ldap-parent', value: Util.getCNfromParentDN(app.odAppParent) }
    ]);
    const wrapperNode = DomHelper.appendNode(appNode, 'div', ['rudi-app-wrapper'], []);
    DomHelper.addAppIcon(wrapperNode, app);
    DomHelper.appendNode(wrapperNode, 'h2', ['rudi-app-title'], [], Util.formatTitle(app));
    DomHelper.appendNode(wrapperNode, 'h3', ['rudi-app-subtitle'], [], (typeof app.odAppSubTitle != "undefined") ? Util.replaceWithPlaceholder(app.odAppSubTitle, myJSON) : "");
    if (networkRestricted) {
        DomHelper.appendNode(wrapperNode, 'div', ['rudi-app-reject'], [], "aus dem aktuellen Netzwerk nicht erreichbar");
        additionalClassList.push('rudi-network-restriction');
    }
    else
        DomHelper.appendNode(wrapperNode, 'div', ['rudi-app-inject', 'disabled'], []);
    const descriptionNode = DomHelper.appendNode(wrapperNode, 'div', ['rudi-app-desc', 'disabled'], [], app.odAppDescription ? app.odAppDescription : "");
    if (app.consentRequired) {
        additionalClassList === null || additionalClassList === void 0 ? void 0 : additionalClassList.push('disabledbymessage');
        DomHelper.addToolTip(appNode, 'Sie müssen erst die Bedingungen akzeptieren, bevor Sie die App benutzen können.', `tt-${app.cn}`);
    }
    if (app.odAppSizeRow != null && Number(app.odAppSizeRow) > 1)
        additionalClassList.push(`rudi-row-span-${app.odAppSizeRow}`);
    if (app.odAppSizeCol != null && Number(app.odAppSizeCol) > 1)
        additionalClassList.push(`rudi-col-span-${app.odAppSizeCol}`);
    if (!networkRestricted) {
        href = app.odAppLocation ? Util.getLinkWithReplacements(app.odAppLocation, myJSON) : "";
        if (typeof clickHandler == 'boolean' && clickHandler) {
        }
        else {
            wrapperNode.addEventListener('click', (event) => {
                if (appNode.classList.contains('disabledbymessage')) {
                    console.log("Card disabled by message");
                    if (logEvents)
                        Util.logMessage(bearerToken, sessionid, app.cn, "click-disabled", "disabled by message");
                    return;
                }
                if (logEvents)
                    Util.logMessage(bearerToken, sessionid, app.cn, "click", href);
                if (clickHandler) {
                    if (DEBUG)
                        console.log("use clickhandler");
                    clickHandler(event);
                }
                else {
                    if (DEBUG)
                        console.log("use default clickhandler");
                    handleDefaultClick(event, href);
                }
            });
        }
        additionalClassList.push('rudi-pointer');
        additionalClassList.push('rudi-app-link');
    }
    if (additionalClassList) {
        for (const className of additionalClassList)
            appNode.classList.add(className);
    }
    if (!appConfig.hidefooter) {
        const footerNode = DomHelper.appendNode(appNode, 'footer', [], []);
        DomHelper.appendFavoriteIcon(footerNode, app, userPreferences, username, bearerToken, addToFavorites, removeFavorites);
        DomHelper.appendColorpickerIcon(footerNode, app, userPreferences, username, bearerToken, addToFavorites, removeFavorites);
        DomHelper.appendDescIcon(footerNode, descriptionNode, appNode, app.odAppDescription);
        DomHelper.appendHelpIcon(footerNode, app.odAppHelpLocation, handleHelpClick);
    }
    return appNode;
}
function addToFavorites(node, username, prefs, bearerToken) {
    if (DEBUG)
        console.log("-->addToFavorites");
    try {
        const appNode = DomHelper.getFirstParentWithClass(node, "rudi-app");
        const parentNode = document.getElementById("rudi-favorites_section");
        parentNode === null || parentNode === void 0 ? void 0 : parentNode.appendChild(appNode);
        DomHelper.enableGroupByDN("rudi-favorites");
        const groupDN = node.getAttribute("rudi-group-dn");
        if (groupDN) {
            if (prefs.favorites.indexOf(groupDN) >= 0) {
            }
            else {
                prefs.favorites.push(groupDN);
            }
        }
        sendBackendData('', `/users/${username.toLowerCase()}/settings`, "PUT", 'application/json', bearerToken, prefs, (response) => {
            if (DEBUG)
                console.log("User Pref saved", response);
        });
    }
    catch (e) {
        console.log("Didn't find app node");
    }
}
function removeFavorites(node, username, prefs, bearerToken) {
    try {
        const appNode = DomHelper.getFirstParentWithClass(node, "rudi-app");
        const parentNode = document.getElementById((appNode === null || appNode === void 0 ? void 0 : appNode.getAttribute("ldap-parent")) + "_section");
        parentNode === null || parentNode === void 0 ? void 0 : parentNode.appendChild(appNode);
        const groupDN = node.getAttribute("rudi-group-dn");
        if (groupDN) {
            if (prefs.favorites.indexOf(groupDN) >= 0) {
                prefs.favorites.splice(prefs.favorites.indexOf(groupDN), 1);
            }
        }
        sendBackendData('', `/users/${username.toLowerCase()}/settings`, "PUT", 'application/json', bearerToken, prefs, (response) => {
            if (DEBUG)
                console.log("User Pref saved", response);
        });
    }
    catch (e) {
        console.log("Didn't find app node");
    }
}
